import { jsxs as t, Fragment as d, jsx as s } from "react/jsx-runtime";
import { useMemo as r } from "react";
import { Link as P } from "react-router-dom";
import { c } from "../../index-C7ezJk5b.js";
import { G as D } from "../../iconBase-DkR9t2l_.js";
import { I as R, a as L, b as N } from "../../auto_suggest_documents-B-2XpRS7.js";
import { AppId as b } from "../../core/models/PlatformNavigation.js";
import { b as v, R as o, S as y } from "../../base-nYmjnkiN.js";
import { getEnding as F } from "../../core/utils/string.js";
import { sanitize as x } from "../../core/utils/url.js";
import { cssX as n, cssTI as A } from "../../core/utils/css.js";
import { getFormattedThousand as w } from "../../core/utils/number.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import m, { GlobalSearchResultsCardFooter as j } from "./GlobalSearchResultsGroup.js";
import l from "./GlobalSearchResultsCategory.js";
function k(i) {
  return D({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M19.1642 12L12.9571 5.79291L11.5429 7.20712L16.3358 12L11.5429 16.7929L12.9571 18.2071L19.1642 12ZM13.5143 12L7.30722 5.79291L5.89301 7.20712L10.6859 12L5.89301 16.7929L7.30722 18.2071L13.5143 12Z" }, child: [] }] })(i);
}
const Y = ({
  isLoading: i,
  data: e
}) => {
  const u = v(), {
    userInfo: { snapChainsInMenuUrl: p },
    globalSearch: { query: a, setIsOpened: f },
    appId: h
  } = u, g = r(
    () => e[o.FoodProfiles].items.length > 0 || e[o.MacInstantCharts].items.length > 0,
    [e]
  ), C = r(
    () => e[o.ChainProfiles].items.length > 0 || e.chainsInMenuCount > 0 || e[o.ReportProDocuments].items.length > 0 || e[o.MyDocsDocuments].items.length > 0,
    [e]
  ), G = r(
    () => e[o.ChainProfiles].items.length > 0 || e.chainsInMenuCount > 0,
    [e]
  ), M = r(
    () => e[o.ReportProDocuments].items.length > 0 || e[o.MyDocsDocuments].items.length > 0,
    [e]
  ), _ = r(
    () => {
      const S = {
        onClick: () => {
          h === b.Snap && f(!1);
        },
        children: /* @__PURE__ */ t(d, { children: [
          "on the menu at",
          " ",
          w(e.chainsInMenuCount),
          " ",
          F("chain", e.chainsInMenuCount),
          /* @__PURE__ */ s(k, { className: n("GlobalSearchGroup__footer-icon") })
        ] })
      }, I = x(`/${p}${a}`);
      return h === b.Snap ? /* @__PURE__ */ s(P, { to: I, ...S }) : /* @__PURE__ */ s("a", { href: y.getSnapInternalUrl(I, u), ...S });
    },
    [e.chainsInMenuCount, p, a, f, h]
  );
  return /* @__PURE__ */ s("div", { className: c(n("GlobalSearch__body")), children: !i && !e.isPending && /* @__PURE__ */ t(d, { children: [
    g && /* @__PURE__ */ s("div", { className: c(n("GlobalSearch__left")), children: /* @__PURE__ */ t(m, { title: "Food", className: "is-food", isCol: !0, children: [
      e[o.FoodProfiles].items.length > 0 && /* @__PURE__ */ s(l, { data: e[o.FoodProfiles] }),
      e[o.MacInstantCharts].items.length > 0 && /* @__PURE__ */ s(l, { data: e[o.MacInstantCharts] }),
      /* @__PURE__ */ s(R, { className: n("GlobalSearchGroup__icon") })
    ] }) }),
    C && /* @__PURE__ */ t("div", { className: c(n("GlobalSearch__right")), children: [
      G && /* @__PURE__ */ t(m, { title: "Places", className: "is-places", children: [
        /* @__PURE__ */ s(
          l,
          {
            data: e[o.ChainProfiles],
            columnsCount: 3,
            placeholder: "No matching chains."
          }
        ),
        e.chainsInMenuCount > 0 && /* @__PURE__ */ s(
          j,
          {
            testId: A("button", "SearchPopupCategoryChainsAlternativeResults"),
            children: _
          }
        ),
        /* @__PURE__ */ s(L, { className: n("GlobalSearchGroup__icon") })
      ] }),
      M && /* @__PURE__ */ t(m, { title: "Documents", className: "is-documents", children: [
        e[o.ReportProDocuments].items.length > 0 && /* @__PURE__ */ s(l, { data: e[o.ReportProDocuments] }),
        e[o.MyDocsDocuments].items.length > 0 && /* @__PURE__ */ s(l, { data: e[o.MyDocsDocuments] }),
        /* @__PURE__ */ s(N, { className: n("GlobalSearchGroup__icon") })
      ] })
    ] }),
    !g && !C && /* @__PURE__ */ s("div", { className: c(n("GlobalSearch__no-data")), children: /* @__PURE__ */ t("div", { className: c(n("GlobalSearch__no-data-inner")), children: [
      "Hmm... SNAP covers thousands of topics, but we don’t seem to have anything on “",
      a,
      "”. Please try searching for something else."
    ] }) })
  ] }) });
};
export {
  Y as default
};
